import { render, staticRenderFns } from "./Applyset.vue?vue&type=template&id=21268a08&scoped=true&"
import script from "./Applyset.vue?vue&type=script&lang=js&"
export * from "./Applyset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21268a08",
  null
  
)

export default component.exports